import { useSelector } from 'react-redux';
import { authSelector } from 'store/auth';
// import styles from 'styles/modules/SidescreenAddExpert.module.scss';
import styles from 'styles/modules/SidescreenEditCompanyInfo.module.scss';
import { useState } from 'react';
import { profile } from 'lang/en.json';
import Typo from 'components/Typo';

const Description = (props) => {
    const { isAuthorized } = useSelector(authSelector);
    const [val, setVal] = useState(props.description || '');

    const handleChange = (e) => {
        setVal(e.target.value);

        if (props.callback) {
            props.callback(e.target.value);
        }
    };

    return (
        <div className={styles.description}>
            <div className={['mb-xxs', styles.descriptionHeader].join(' ')}>
                <Typo variant={'body'} Tag={'label'} htmlFor="description">
                    {isAuthorized
                        ? profile.header.experts.sidebar.bio
                        : profile.header.experts.sidebar.bio_public}
                </Typo>
            </div>

            <textarea
                name="description"
                id="description"
                className={styles.descriptionTextarea}
                onChange={handleChange}
                defaultValue={val}
            />
        </div>
    );
};

export default Description;
